var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_box"},[_c('div',{staticClass:"footer_con"},[_vm._v(" Copyright © 2016 - "+_vm._s(_vm.years)+" 淘韓網 taohan.kr 版權所有 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }